import { render, staticRenderFns } from "./BannerSyncForm.vue?vue&type=template&id=097f001c&"
import script from "./BannerSyncForm.vue?vue&type=script&lang=js&"
export * from "./BannerSyncForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports